import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { logout } from '../../redux/auth/login/actions';
import { selectFullName, selectInitials } from './selectors';

import UserMenu from './UserMenu';

const UserMenuConnected = (props) => <UserMenu {...props} />;

const mapActionsToProps = {
  logout,
  push,
};

const mapStateToProps = (state) => ({
  fullName: selectFullName(state),
  initials: selectInitials(state),
});

export default connect(mapStateToProps, mapActionsToProps)(UserMenuConnected);
